// Utility function to clear all authentication state
// This is useful for testing and debugging authentication issues

export const clearAllAuthState = () => {
    console.log('[clearAllAuthState] Clearing all authentication state');
    
    // Clear direct authentication
    localStorage.removeItem('directAuthUser');
    sessionStorage.removeItem('autoLoginActive');
    
    // Clear user data
    localStorage.removeItem('user');
    
    // Clear any Auth0 tokens (these are stored in memory by Auth0 SDK)
    // The Auth0 SDK manages its own token storage
    
    // Clear any other auth-related localStorage items
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('auth0') || key.includes('token') || key.includes('auth'))) {
            keysToRemove.push(key);
        }
    }
    
    keysToRemove.forEach(key => {
        console.log(`[clearAllAuthState] Removing localStorage key: ${key}`);
        localStorage.removeItem(key);
    });
    
    console.log('[clearAllAuthState] All authentication state cleared');
    
    // Return true to indicate success
    return true;
};

// Test function to check current authentication state
export const checkAuthState = () => {
    console.log('[checkAuthState] Current authentication state:');
    console.log('- directAuthUser:', localStorage.getItem('directAuthUser'));
    console.log('- autoLoginActive:', sessionStorage.getItem('autoLoginActive'));
    console.log('- user:', localStorage.getItem('user'));
    
    // Check for any auth-related localStorage items
    const authKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('auth0') || key.includes('token') || key.includes('auth'))) {
            authKeys.push(key);
        }
    }
    
    if (authKeys.length > 0) {
        console.log('- Other auth-related keys:', authKeys);
    } else {
        console.log('- No other auth-related keys found');
    }
    
    return {
        directAuthUser: localStorage.getItem('directAuthUser'),
        autoLoginActive: sessionStorage.getItem('autoLoginActive'),
        user: localStorage.getItem('user'),
        otherAuthKeys: authKeys
    };
};
